import * as WebBrowser from 'expo-web-browser';
import React, { useEffect } from 'react';
import { FlatList, StyleSheet, TouchableOpacity, Linking } from 'react-native';
import * as ical2json from 'ical2json';
import * as moment from 'moment';

import Colors from '../constants/Colors';
import { MonoText } from './StyledText';
import { Text, View } from './Themed';
import { Card } from 'react-native-elements';
import { ActivityIndicator } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

export default function CalendarComponent() {
  const [calendar, setCalendar] = React.useState<Array<any>>([]);
  const [loading, setLaoding] = React.useState<Boolean>(true);
  // const redirect = (event: any) => console.log(event) 

  React.useEffect(() => {

    let call = async () => {
      const response = await fetch('https://pedozi-proxy.herokuapp.com/pedozi-app/calendar', {
        method: 'get'
      })
      const calendarAsText = await response.text()
      const unwrapped = ical2json.convert(calendarAsText)
      
      setCalendar(unwrapped.VCALENDAR[0].VEVENT.map((result: any) => {
        return {
          start: result['DTSTART;TZID=Europe/Amsterdam'] ? result['DTSTART;TZID=Europe/Amsterdam'] : result['DTSTART;VALUE=DATE'],
          end: result['DTEND;TZID=Europe/Amsterdam'] ? result['DTEND;TZID=Europe/Amsterdam'] : result['DTEND;VALUE=DATE'],
          title: result.SUMMARY,
          url: result.URL,
          location: result.LOCATION
       }
      })
      .filter((el: any) => moment(el.start).isAfter())
      .sort((left: any, right: any) => moment(left.start).diff(moment(right.start))))
      setLaoding(false)
  }
  call()}, [])
  
  return (
    <View style={styles.container}>
      <Card>
      <Card.Title><MaterialIcons name="calendar-today" size={ 36 }  /></Card.Title>
      <Card.Divider/>
        {
                loading ? <>
                  <ActivityIndicator size="large" color="#0fa8e4ff"  />
                </> : <>
                <FlatList 
              style={styles.floater}
              data={calendar}
              renderItem={({ item }) => <TouchableOpacity onPress={() => Linking.openURL(item.url)}>{
                item.title  + ' - ' +  moment(item.start).locale('nl').calendar()}</TouchableOpacity>}
            />
                </>
        }
      </Card>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#0fa8e4ff',
  },
  floater: {
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: 5,
    margin: 5
  }
});
